/**
 * Where progression lives. M1: localStorage. From M2/M4 a server-backed store implements the
 * same interface (docs/architecture.md §8).
 */
import type { Progress } from '@caged/shared';

export interface ProgressStore {
  load(): Progress | null;
  save(p: Progress): void;
  clear(): void;
}

const KEY = 'caged.progress.v1';

export class LocalProgressStore implements ProgressStore {
  load(): Progress | null {
    try {
      const raw = localStorage.getItem(KEY);
      if (!raw) return null;
      const p = JSON.parse(raw) as Progress;
      return p.version === 1 ? p : null;
    } catch {
      return null;
    }
  }

  save(p: Progress): void {
    try {
      localStorage.setItem(KEY, JSON.stringify(p));
    } catch {
      // Private mode or full storage: progress stays in memory for this session.
    }
  }

  clear(): void {
    try {
      localStorage.removeItem(KEY);
    } catch {
      // ignore
    }
  }
}

export const progressStore: ProgressStore = new LocalProgressStore();
